import { useEffect, useState } from 'react';

import type { AsdpApi, InboxItem } from '../../asdpApi';

const byWaitingSince = (a: InboxItem, b: InboxItem) =>
  a.waitingSince.localeCompare(b.waitingSince);

/** "Needs you", oldest first; re-read every `pollMs` while the tab is visible. */
export const useInbox = (api: AsdpApi | undefined, pollMs: number) => {
  const [items, setItems] = useState<InboxItem[]>();
  const [error, setError] = useState<Error>();
  const [reloadKey, setReloadKey] = useState(0);

  useEffect(() => {
    if (!api) return undefined;
    let cancelled = false;
    const load = async () => {
      if (document.visibilityState === 'hidden') return;
      try {
        const inbox = await api.getInbox();
        if (cancelled) return;
        setItems([...inbox.items].sort(byWaitingSince));
        setError(undefined);
      } catch (inboxError) {
        if (cancelled) return;
        setError(
          inboxError instanceof Error
            ? inboxError
            : new Error("What needs you couldn't be loaded."),
        );
      }
    };
    void load();
    const timer = globalThis.setInterval(load, pollMs);
    return () => {
      cancelled = true;
      globalThis.clearInterval(timer);
    };
  }, [api, pollMs, reloadKey]);

  return { items, error, reload: () => setReloadKey(key => key + 1) };
};
